import React from 'react';
import MUIButton from '@mui/material/Button';
import { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export type ButtonProps = {
    onClickHandler: () => void;
    id?: string;
    label: string;
    disabled?: boolean;
    variant?: MuiButtonProps['variant'];
    fullWidth?: boolean;
};

const Button = ({ onClickHandler, id, label, disabled, variant, fullWidth }: ButtonProps): JSX.Element => {
    const buttonVariant = variant ? variant : 'contained';
    return (
        <MUIButton
            onClick={() => onClickHandler()}
            disabled={disabled}
            variant={buttonVariant}
            fullWidth={fullWidth}
            id={id}
        >
            {label}
        </MUIButton>
    );
};

export default Button;
